import { render, staticRenderFns } from "./tree-table.vue?vue&type=template&id=c36861c0&scoped=true&"
import script from "./tree-table.vue?vue&type=script&lang=js&"
export * from "./tree-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36861c0",
  null
  
)

export default component.exports